<template>
    <div class="sw-survey-container">
        <div class="sw-width-full" v-if="!success">
            <a ref="openPdf" :href="origin+'/api/form/'+form.id+'/white-paper/pdf/open'" hidden></a>
            <form ref="form"
                  method="POST" @submit.prevent="submit">
                <div class="sw-contact-form">
                    <component :key="index"
                               v-for="(component,index) of form.form_components"
                               :component="component"
                               @updateContact="fillForm($event)"
                               :is="`form-${component.component}`"
                               :id="component.id">
                        <component :key="childIndex"
                                   v-if="component.children"
                                   :class="child.attributes.inputSize"
                                   v-for="(child,childIndex) of component.children"
                                   :component="child"
                                   @updateContact="fillForm($event)"
                                   :is="`form-${child.component}`"
                                   :id="child.id"></component>
                    </component>
                </div>
                <div class="sw-mt-2 sw-mr-1 sw-ml-1">
                    <div class="sw-flex sw-mb-1 sw-align-center">
                        <input  class="form-checkbox sw-checkbox"
                                type="checkbox"
                                v-model="termsAndConditions">
                        <p class="sw-ml-1 sw-accept" v-html="form.settings.termsAndConditions"></p>
                    </div>
                    <div class="sw-flex sw-mb-1 sw-align-center">
                        <input class="form-checkbox sw-checkbox"
                               type="checkbox"
                               v-model="privacyPolicy">
                        <p class="sw-ml-1 sw-accept" v-html="form.settings.privacyPolicy"></p>
                    </div>
                </div>
                <div v-if="cantSubmitText.length" class="sw-flex sw-justify-end sw-container">
                    <p class="sw-bad">{{ cantSubmitText }}</p>
                </div>
                <div class="sw-flex sw-justify-end">
                    <button :class="{'opacity-50': loading}" type="submit" class="sw-btn">
                        Jetzt downloaden
                    </button>
                </div>
            </form>
        </div>
        <template v-else>
            <div id="sw-anchor-2"></div>
            <div class="sw-mx-auto sw-thanks-message">
                {{ form.thanks_message }}
            </div>
            <div class="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-md"
                 :class="show?'show':'hidden'">
                <div class="relative p-4 w-full max-w-md max-h-full">
                    <div class="relative bg-white rounded-lg shadow">
                        <div class="p-4 md:p-5 text-center">
                            <div>
                                <div class="flex justify-center items-center mb-5">
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" enable-background="new 0 0 512 512" height="70" viewBox="0 0 512 512" width="70" fill="#00AE8F"><path d="m432 192h-125.25c-27.99 0-50.75-22.76-50.75-50.75v-125.25c0-5.76 1.52-11.24 4.27-16h-161.52c-19.16 0-34.75 15.59-34.75 34.75v442.5c0 19.16 15.59 34.75 34.75 34.75h314.5c19.16 0 34.75-15.59 34.75-34.75v-289.52c-4.76 2.75-10.24 4.27-16 4.27zm-235.31 100.69c6.25-6.25 16.37-6.25 22.62 0l20.69 20.68v-97.37c0-8.84 7.16-16 16-16s16 7.16 16 16v97.37l20.69-20.68c6.24-6.25 16.38-6.25 22.62 0 6.25 6.24 6.25 16.38 0 22.62l-48 48c-3.373 3.46-8.231 5.022-12.85 4.62-8.012-1.07-5.485-.335-57.77-52.62-6.25-6.24-6.25-16.38 0-22.62zm139.31 139.31h-160c-8.84 0-16-7.16-16-16s7.16-16 16-16h160c8.84 0 16 7.16 16 16s-7.16 16-16 16zm-29.25-272h125.25l-144-144v125.25c0 10.34 8.41 18.75 18.75 18.75z"/></svg>
                                </div>
                                <h3 class="mb-5 text-xl font-normal text-gray-800 font-semibold">
                                    PDF-Download wurde gestartet
                                </h3>
                                <p class="mb-5 text-base font-normal text-gray-500">
                                    Der PDF-Download wurde automatisch gestartet und kann über die heruntergeladenen Dateien geöffnet werden.
                                </p>
                            </div>
                            <button  @click="show = false" class="bg-sw text-center items-center px-4 py-2 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest focus:outline-none focus:shadow-outline-gray transition ease-in-out duration-150">Okay verstanden</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import FormCheckbox from '@/Pages/Forms/Partials/Checkbox.vue'
import Form from '@/Pages/Forms/Partials/Form.vue'
import FormInput from '@/Pages/Forms/Partials/Input.vue'
import FormDate from '@/Pages/Forms/Partials/Date.vue'
import FormTextarea from '@/Pages/Forms/Partials/Textarea.vue'
import FormSelect from '@/Pages/Forms/Partials/Select.vue'
import FormColumn from '@/Pages/Forms/Partials/Column.vue'
import FormButton from '@/Pages/Forms/Partials/Button.vue'
import axios from "axios";
import FormScalaQuestion from "@/Pages/Forms/Partials/ScalaQuestion.vue";
import FormSlide from "@/Pages/Forms/Partials/Slide.vue";

export default {
    name: "PublicWhitePaper",
    components: {
        FormCheckbox,
        FormColumn,
        FormInput,
        FormDate,
        Form,
        FormTextarea,
        FormSelect,
        FormButton,
        FormScalaQuestion,
        FormSlide
    },
    props: {
        form: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            whitePaperData: {},
            success: false,
            loading: false,
            cantSubmitText:'',
            termsAndConditions: false,
            privacyPolicy: false,
            show: false
        }
    },
    computed: {
        canSubmit() {
            return this.termsAndConditions && this.privacyPolicy;
        },
        origin() {
            if (typeof this.form.origin !== 'undefined') {
                return this.form.origin;
            }
            return 'https://tracker.schubwerk.de';
        }
    },
    methods: {
        fillForm(ev) {
            if (!Object.keys(this.whitePaperData).includes(ev.id)) {
                this.$set(this.whitePaperData, ev.id, ev.value);
                this.$forceUpdate();
            } else {
                this.whitePaperData[ev.id] = ev.value;
                this.$forceUpdate();
            }
        },
        async submit($event) {
            if(this.canSubmit) {
                this.loading = true;
                $event.preventDefault();
                const payload = {
                    whitePaperData: this.whitePaperData,
                    url: window.location.href,
                    useragent: window.navigator.userAgent
                };
                await axios.post(this.origin+'/api/form/'+this.form.id+'/submit/white-paper', payload, {
                    method : "POST",
                    mode: 'cors',
                }).then(response => {
                    this.loading = false;
                    this.success = true;
                    if (this.form.settings.hasOwnProperty('pdfTemplate') && this.form.settings.pdfTemplate) {
                        this.show = true;
                        this.$refs.openPdf.click();
                    }
                }).catch(() => {
                    this.loading = false;
                });
            } else {
                this.cantSubmitText = 'Einige der Fragen wurden nicht beantwortet oder die Datenschutzerklärung wurde nicht ausgewählt.'
                setTimeout(() => {
                    this.cantSubmitText = ''
                }, 5000)
            }
        }
    }
}
</script>

<style scoped>
.show {
    display: block;
}
.hidden {
    display: none;
}
.fixed {
    position: fixed;
}
.top-1\/2 {
    top: 50%;
}
.left-1\/2 {
    left: 50%;
}
.transform {
    transform: translate(-50%, -50%);
}
.z-50 {
    z-index: 50;
}
.w-full {
    width: 100%;
}
.max-w-md {
    max-width: 28rem;
}
.show {
    display: block;
}
.relative {
    position: relative;
}
.p-4 {
    padding: 1rem;
}
.text-center {
    text-align: center;
}
.bg-white {
    background-color: #fff;
}
.rounded-lg {
    border-radius: 0.75rem;
}
.shadow {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
.mb-5 {
    margin-bottom: 1.25rem;
}
.text-xl {
    font-size: 1.25rem;
}
.font-normal {
    font-weight: 400;
}
.text-gray-800 {
    color: #2d3748;
}
.font-semibold {
    font-weight: 600;
}
.text-base {
    font-size: 1rem;
}
.text-gray-500 {
    color: #718096;
}
.flex {
    display: flex;
}
.justify-center {
    justify-content: center;
}
.items-center {
    align-items: center;
}
.px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
}
.py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.border {
    border-width: 1px;
    border-style: solid;
}
.border-transparent {
    border-color: transparent;
}
.rounded-md {
    border-radius: 0.375rem;
}
.font-semibold {
    font-weight: 600;
}
.text-xs {
    font-size: 0.75rem;
}
.text-white {
    color: #fff;
}
.uppercase {
    text-transform: uppercase;
}
.tracking-widest {
    letter-spacing: 0.125em;
}
.focus\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
}
.focus\:shadow-outline-gray:focus {
    box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.5);
}
.transition {
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
}
.ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.duration-150 {
    transition-duration: 150ms;
}
h3, p{
    font-family: Poppins;
}
.bg-sw{
    background-color: #00AE8F;
}
</style>
